import { useCallback } from "react";
import { Navigate, useLocation, useNavigate } from "react-router";

export function useSteps(steps: string[]) {
  const navigate = useNavigate();
  const location = useLocation();

  const activeStep = Math.max(
    steps.findIndex((step) => location.pathname.endsWith(step)),
    0,
  );

  const previousStep = useCallback(() => {
    const prev = Math.max(activeStep - 1, 0);
    navigate(steps[prev]);
  }, [activeStep, navigate, steps]);

  const nextStep = useCallback(() => {
    const next = Math.min(activeStep + 1, steps.length - 1);
    navigate(steps[next]);
  }, [activeStep, navigate, steps]);

  const reset = useCallback(() => {
    return <Navigate to={`../${steps[0]}`} replace />;
  }, [steps]);

  return { activeStep, nextStep, previousStep, reset };
}
